<template>
  <div
    id="sight"
    class="sights-block obs-el"
    data-attr="sight"
  >
    <Wrap>
      <h2>{{ t('sights') }}</h2>
      <slot />
    </Wrap>
  </div>
</template>

<script lang="ts" setup>
  import { useI18n } from '@experience/i18n';

  import { ru } from '@/pages/cityArticles/widgets/sightsBlock/i18n/ru';
  import Wrap from '@/shared/ui/Wrap.vue';

  const { t } = useI18n({ inheritLocale: true, messages: { ru } });
</script>

<style lang="scss" scoped>
  .sights-block {
    margin-top: 48px;
    padding-bottom: 48px;

    @include tablet {
      margin-top: 80px;
      padding-bottom: 40px;
    }

    @include mobile {
      margin-top: 40px;
    }
  }

  h2 {
    @include base-800-750-extra;

    @include tablet {
      @include base-700-500-extra;
    }
  }
</style>
